import { defineComponent, computed } from "vue";
import { DrawerOptionsData } from "src/layouts/standard/components/navOptions/methods/optionsData";
import { AppStringMethods } from 'src/plugins/string/stringMethods';
import { useAccountStore } from "src/stores/account";
import { useViewStore } from "src/stores/view";
import { useRouter } from "vue-router";
import appDrawerOptionList from "src/layouts/standard/components/navOptions/components/appDrawerOptionList.vue";
import appMultiColoredIcon from "src/components/icon/appMultiColoredIcon.vue";
import genericOptions from "src/layouts/standard/components/navOptions/components/genericOptions.vue";
export default defineComponent({
    name: "standard-options-list",
    props: {
        appIconSize: {
            type: Number,
            default: 36,
        },
        iconRight: Boolean,
        iconSize: {
            type: String,
            default: "1.1rem",
        },
    },
    components: {
        appDrawerOptionList,
        appMultiColoredIcon,
        genericOptions,
    },
    setup() {
        const vueRouter = useRouter();
        const accountStore = useAccountStore();
        const viewStore = useViewStore();
        const { combineStringWithDelimiter } = AppStringMethods();
        // standard options data
        const { appBadge, commonOptions, drawerOptions, drawerOptionShow } = DrawerOptionsData();
        const user = computed(() => accountStore.user);
        /**
         * Logout
         */
        function accLogout() {
            viewStore.toggleDrawer(false);
            vueRouter.push({ name: "Search" });
            accountStore.logout();
        }
        /**
         * Show login dialog
         */
        function login(tab = null) {
            viewStore.requireLogin({
                required: true,
                ...(tab !== null
                    ? { tab }
                    : {})
            });
        }
        /**
         * Map custom non routeable actions
         * @param title
         */
        function action(title) {
            if (title === "Logout") {
                void accLogout();
            }
            else if (title === "Sign Up") {
                void login("register");
            }
            else if (title === "Login") {
                void login();
            }
        }
        return {
            combineStringWithDelimiter,
            user,
            appBadge,
            commonOptions,
            drawerOptions,
            drawerOptionShow,
            action,
            accLogout,
            login,
        };
    },
});
